import UserIcon from '@/CustomIcons/UserIcon'
import { cn } from '@/utlis/cn'
import { useEffect, useState } from 'react'

export function useProfilePic(email: string | undefined) {
    const [url, setUrl] = useState<string>()

    async function sha256(message: string) {
        const msgBuffer = new TextEncoder().encode(message)
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
        const hashArray = Array.from(new Uint8Array(hashBuffer))
        return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
    }

    useEffect(() => {
        if (!email) {
            return
        }

        sha256(email.toLowerCase()).then((h) => {
            setUrl(`https://api.dicebear.com/9.x/glass/svg?seed=${h + ''}&scale=60&backgroundType=gradientLinear`)
            // setUrl(`https://www.gravatar.com/avatar/${h}?d=robohash`)
            // setUrl(`https://robohash.org/${h}.png?size=40x40&bgset=bg1`)
        })
    }, [email])

    return url
}

type GravatarProps = {
    email: string | undefined
    className?: string
}
export function Gravatar(props: GravatarProps) {
    const pfp = useProfilePic(props.email)
    return (
        <div className="flex items-center justify-center">
            {pfp ? <img src={pfp} className={cn('w-[30px] h-[30px] rounded-full', props.className)} /> : <UserIcon />}
        </div>
    )
}
